const getFormattedName = (
  first_name: string | undefined,
  last_name: string | undefined,
  isFullName: boolean = false,
) => {
  const firstName = first_name?.trim() || "NA";
  const lastName = last_name?.trim() || "";
  const fullName = `${firstName} ${lastName}`.trim();

  if (isFullName) return fullName;
  return fullName.length > 7
    ? `${firstName.charAt(0)} ${lastName}` // First letter of first_name + full last_name
    : fullName;
};

export default getFormattedName;
